<template>
  <el-skeleton :loading="loading" :rows="16" animated>

    <el-page class="secretariat-page" :bannerImageUrl="bannerImageUrl">
      <!-- 论坛介绍模块 -->
      <section class="section">
        <pane-title :title="$t('about.secretariat.intro')"></pane-title>
        <div class="forum-intro">
          <!-- 模块左侧图片，宽高比例300/268 -->
          <div class="forum-intro-image">
            <img :src="ltjsImage" />
          </div>
          <!-- 模块右侧大段文字 -->
          <div  :class="lang" class="forum-intro-text">
            <p v-for="(item, index) in ltjsText" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
      </section>

      <!-- 秘书处介绍模块 -->
      <section class="section secretariat">
        <div class="secretariat-content">
          <pane-title :title="$t('about.secretariat.secIntro')"></pane-title>
          <div class="secretariat-intro">
            <!-- 模块右侧大段文字 -->
            <div :class="lang" class="secretariat-intro-text">
              <p v-for="(item, index) in mscjsText" :key="index">
                {{ item }}
              </p>
              <!-- <div class="title">上海金司南金融研究院丨Shanghai Jinsinan Institute of Finance</div> -->
              <!-- <div class="desc">
                <p> 绿色金融60人论坛以上海金司南金融研究院为依托主体展开各项运营活动。</p>
                <p> 上海金司南金融研究院（英文名“Shanghai Jinsinan Institute of
                  Finance”，简称“SHJIF”）是经上海市民政局批准登记的学术性、非营利性组织，主管单位为上海市地方金融监督管理局。研究院智库团队覆盖国内外权威智库专家学者、知名金融机构高管、金融科技与产业公司领军人物，致力于低碳发展、绿色金融、资产管理领域学术研究与实践探索，为地方政府、社会资本及实体企业提供长期智库平台支持，助力实现低碳经济与绿色产业的健康可持续发展。
                </p>
                <p> 上海金司南金融研究院致力于打造绿色金融60人论坛国际化绿色金融交流平台，推动绿色金融标准建设与体系完善，为加快发展绿色产业、服务国家双碳战略目标做出更多的贡献。</p>
              </div> -->
            </div>
            <div class="secretariat-intro-image">
              <img :src="mscjsImage" />
            </div>
          </div>
        </div>
      </section>

      <!-- 愿景使命价值观模块（整张图片，比例1440/861） -->
      <section class="section vision">
        <pane-title :title="$t('about.secretariat.vision')"></pane-title>
        <div class="vision-image">
          <img class="intro-img" :src="yjsmImage" />
          <img class="intro-mobile-img" :src="yjsmMobileImage" />
        </div>
      </section>

      <!-- 组织架构模块（整张图片，比例1440/691） -->
      <section class="section organization">
        <div class="organization-content">
          <pane-title :title="$t('about.secretariat.org')"></pane-title>

          <div class="organization-image">
            <img class="intro-img" :src="zzjgImage" />
            <img class="intro-mobile-img" :src="zzjgMobileImage" />
          </div>
        </div>
      </section>

      <!-- 合作伙伴模块（整张图片，比例1440/900） -->
      <section class="section partners">
        <pane-title :title="$t('about.secretariat.parters')"></pane-title>
        <div class="partners-image">
          <img class="intro-img" :src="hzhbImage" />
          <img class="intro-mobile-img" :src="hzhbMobileImage" />

        </div>
      </section>

      <!-- 里程碑模块（整张图片，比例1440/720） -->
      <section class="section milestones">
        <div class="milestones-content">
          <pane-title :title="$t('about.secretariat.milestone')"></pane-title>
          <div class="milestones-image">
            <img class="intro-img" :src="lcbImage" />
            <img class="intro-mobile-img" :src="lcbMobileImage" />
          </div>
        </div>
      </section>
    </el-page>
  </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
  components: { PaneTitle },
  name: "Secretariat",
  data() {
    return {
      loading: true,
      bannerImageUrl: null,
      ltjsText: null,
      ltjsImage: null,
      mscjsText: null,
      mscjsImage: null,
      yjsmImage: null,
      yjsmMobileImage: null,
      zzjgImage: null,
      zzjgMobileImage: null,
      hzhbImage: null,
      hzhbMobileImage: null,
      lcbImage: null,
      lcbMobileImage: null
    }
  },
  methods: {
    filterData(records) {
      const record901 = records['901'] && records['901'][0] || {}
      this.ltjsText = record901.description && record901.description.split('|') || []
      this.ltjsImage = record901.pcImgUrl
      const record902 = records['902'] && records['902'][0] || {}
      this.mscjsText = record902.description && record902.description.split('|') || []
      this.mscjsImage = record902.pcImgUrl
      const record903 = records['903'] && records['903'][0] || {}
      this.yjsmImage = record903.jumpUrl
      const record993 = records['993'] && records['993'][0] || {}
      this.yjsmMobileImage = record993.jumpUrl
      const record904 = records['904'] && records['904'][0] || {}
      this.zzjgImage = record904.jumpUrl
      const record994 = records['994'] && records['994'][0] || {}
      this.zzjgMobileImage = record994.jumpUrl
      const record905 = records['905'] && records['905'][0] || {}
      this.hzhbImage = record905.jumpUrl
      const record995 = records['995'] && records['995'][0] || {}
      this.hzhbMobileImage = record995.jumpUrl
      const record906 = records['906'] && records['906'][0] || {}
      this.lcbImage = record906.jumpUrl

      const record996 = records['996'] && records['996'][0] || {}

      this.lcbMobileImage = record996.jumpUrl
      // this.expertList = records['601'].sort((a, b) => a.sort - b.sort);
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '9',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
        this.bannerImageUrl = res.imageMaps && res.imageMaps['90'] && res.imageMaps['90'][0] && res.imageMaps['90'][0].imgUrl;
        this.loading = false
      });
    },
    getDataByLang(lang) {
      if (lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    },
  }
};
</script>

<style scoped lang="less">
.secretariat-page {
  .section {
    padding: 2rem 0;
  }

  .forum-intro {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2.5rem;

    &-image {
      flex: 0 0 18rem;
      //   aspect-ratio: 6 / 5;
      margin-right: 6rem;

      img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    &-text {
      flex: 1;

      p {
        display: block;
        color: #494949;
        line-height: 2rem;
        text-align: justify;
    //    text-indent: 2rem;
      }
    }
  }

  .secretariat,
  .organization,
  .milestones {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100vw;
      height: 100%;
      background: linear-gradient(180deg, rgba(3, 118, 152, 0.2) 0%, rgba(3, 118, 152, 0.05) 100%);
    }
  }

  .secretariat-content,
  .organization-content,
  .milestones-content {

    //width: var(--layout-max-width);
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  .secretariat-intro {

    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2.5rem;

    &-image {
      flex: 0 0 18rem;
      //   aspect-ratio: 16 / 10;
      margin-right: 6rem;

      img {
        display: block;

        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    &-text {
      flex: 1;
      margin-right: 4rem;

      .title {
        font-weight: bold;
        margin-bottom: 2rem;
      }

      p {
        display: block;
        color: #494949;
        line-height: 2rem;
        text-align: justify;
      //  text-indent: 2rem;
      }
    }
  }

  .vision {
    &-image {
      margin-top: 2.5rem;
      width: 100%;
      // aspect-ratio: 16 / 10;

      img {
        display: block;

        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
  }

  .organization {
    &-image {
      margin-top: 2.5rem;
      width: 100%;
      //  aspect-ratio: 16 / 9;

      img {
        display: block;

        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
  }

  .partners {
    &-image {
      margin-top: 2.5rem;
      width: 100%;
      // aspect-ratio: 8 / 5;

      img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
  }

  .milestones {
    padding-bottom: 0;

    &-image {
      margin-top: 2.5rem;
      width: 100%;
      //   aspect-ratio: 2 / 1;

      img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
  }
}


/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
  .secretariat-page {
    font-size: 14px;

    .forum-intro {
      flex-direction: column;

      &-image {
        flex: 1;
        width: 60%;
        margin-right: 0;
        margin-bottom: 1.2rem;
      }
    }


    .secretariat-content{
      /deep/ .pane-title {
        .title {
          font-size: 1.4rem;
          margin: 0 0.8rem;
        }
      }
    }

    .secretariat-intro {
      flex-direction: column-reverse;

      &-image {
        flex: 1;
        width: 60%;
        margin-right: 0;
        margin-bottom: 1.2rem;
      }

      &-text {
        margin-right: 0;
      }
    }

    .intro-img {
      display: none !important;
    }

    /deep/ .pane-title {
      .title {
        font-size: 1.5rem;
        margin: 0 1rem;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .secretariat-page {
    .intro-mobile-img {
      display: none !important;
    }
  }
}
</style>